"use client";

import React, { useState } from 'react'
import Button from 'bwax-ui/components/Button'
import { RiShieldKeyholeLine } from "react-icons/ri"

export default function SamlLogin({ onSuccess }) {
    const [isLoading, setIsLoading] = useState(false)
    
    const handleSamlLogin = async () => {
        setIsLoading(true)
        try {
            // 获取当前页面路径作为返回地址
            const returnTo = window.location.pathname + window.location.search
            
            // 重定向到 SAML 登录端点
            window.location.href = `/api/auth/saml/login?returnTo=${encodeURIComponent(returnTo)}`
        } catch (error) {
            console.error('SAML login error:', error)
            setIsLoading(false)
        }
    }
    
    return (
        <div className="flex flex-col gap-4 mt-1.5">
            <div className="flex flex-col gap-3 mb-5">
                <Button 
                    appearance="primary" 
                    color="main" 
                    size="xlarge" 
                    className="w-full"
                    isLoading={isLoading}
                    onPress={handleSamlLogin}
                >
                    <div className="flex items-center gap-2">
                        <RiShieldKeyholeLine />
                        使用 SSO 登录
                    </div>
                </Button>
            </div>
            <div className="font-size-13 text-[var(--gray-9)] text-center">
                点击将跳转到企业单点登录页面
            </div>
        </div>
    )
} 